import { registerDashboardWidget, registerFormInputComponent } from '@vendure/admin-ui/core';
import { TaxRateSelector } from './tax-rate.selector.component';

export default [
    registerFormInputComponent('global-settings-loyalty-tax-rate', TaxRateSelector),
    registerDashboardWidget('all-loyaltys', {
        title: 'All Loyalty Points',
        supportedWidths: [12],
        loadComponent: () =>
            import('./widget/all-loyaltys.component').then(
                m => m.AllLoyaltysWidgetComponent
            ),
    }),
];
